import DateField from './DateField.jsx';

// DateTimeField — drop-in replacement for <input type="datetime-local">.
// Combines the custom DateField (date) with simple hour / minute / AM-PM
// selects. value/onChange use the native "YYYY-MM-DDTHH:MM" shape, and
// onChange fires { target: { value } } so existing handlers keep working.

const pad = (n) => String(n).padStart(2, '0');
const parse = (v) => {
  const m = /^(\d{4}-\d{2}-\d{2})[T ](\d{2}):(\d{2})/.exec(String(v || ''));
  if (m) return { date: m[1], h: +m[2], min: +m[3] };
  const d = /^(\d{4}-\d{2}-\d{2})$/.exec(String(v || ''));
  if (d) return { date: d[1], h: null, min: null };
  return { date: '', h: null, min: null };
};

const selStyle = {
  padding: '.45rem .4rem', borderRadius: 8, border: '1px solid var(--c-border,#1a3550)',
  background: 'var(--c-surface,#0d1c2e)', color: 'var(--c-white,#eef6ff)', fontSize: '.82rem',
  fontFamily: 'inherit', cursor: 'pointer',
};

export default function DateTimeField({ value, onChange, lang, min, max, disabled }) {
  const p = parse(value);
  const has = !!p.date;
  // Default time to 09:00 when a date is picked but no time set yet.
  const h24 = p.h == null ? 9 : p.h;
  const min0 = p.min == null ? 0 : p.min;
  const ampm = h24 >= 12 ? 'PM' : 'AM';
  const h12 = ((h24 + 11) % 12) + 1;

  const fire = (date, hour24, minute) => {
    if (!date) { onChange && onChange({ target: { value: '' } }); return; }
    onChange && onChange({ target: { value: `${date}T${pad(hour24)}:${pad(minute)}` } });
  };
  const onDate = (e) => fire(e.target.value, h24, min0);
  const onHour = (e) => { const nh12 = +e.target.value; const nh24 = ampm === 'PM' ? (nh12 % 12) + 12 : (nh12 % 12); fire(p.date, nh24, min0); };
  const onMin = (e) => fire(p.date, h24, +e.target.value);
  const onAmPm = (e) => { const np = e.target.value; const nh24 = np === 'PM' ? (h12 % 12) + 12 : (h12 % 12); fire(p.date, nh24, min0); };

  return (
    <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
      <div style={{ flex: '1 1 150px', minWidth: 140 }}>
        <DateField value={p.date} onChange={onDate} lang={lang} min={min} max={max} disabled={disabled} />
      </div>
      <select value={h12} onChange={onHour} disabled={disabled || !has} style={selStyle} title="Hora / Hour">
        {Array.from({ length: 12 }, (_, i) => i + 1).map((h) => <option key={h} value={h}>{h}</option>)}
      </select>
      <span style={{ color: 'var(--c-text3,#45688a)', fontWeight: 700 }}>:</span>
      <select value={min0} onChange={onMin} disabled={disabled || !has} style={selStyle} title="Minutos / Minutes">
        {Array.from({ length: 60 }, (_, i) => i).map((mn) => <option key={mn} value={mn}>{pad(mn)}</option>)}
      </select>
      <select value={ampm} onChange={onAmPm} disabled={disabled || !has} style={selStyle}>
        <option value="AM">AM</option>
        <option value="PM">PM</option>
      </select>
    </div>
  );
}
